import type {
  FeedbackDetailResponseDto,
  FeedbackResponseDto,
} from "@pro-sto/api-client";

export const FEEDBACK_STATUS_LABEL: Record<FeedbackResponseDto["status"], string> =
  {
    new: "Новое",
    in_progress: "В работе",
    resolved: "Решено",
    closed: "Закрыто",
  };

export const FEEDBACK_STATUS_COLOR: Record<
  FeedbackResponseDto["status"],
  "warning" | "accent" | "success" | "default"
> = {
  new: "warning",
  in_progress: "accent",
  resolved: "success",
  closed: "default",
};

export const FEEDBACK_STATUS_OPTIONS: Array<{
  value: FeedbackResponseDto["status"];
  label: string;
}> = [
  { value: "new", label: FEEDBACK_STATUS_LABEL.new },
  { value: "in_progress", label: FEEDBACK_STATUS_LABEL.in_progress },
  { value: "resolved", label: FEEDBACK_STATUS_LABEL.resolved },
  { value: "closed", label: FEEDBACK_STATUS_LABEL.closed },
];

export const FEEDBACK_STATUS_FILTER_OPTIONS: Array<{
  value: FeedbackResponseDto["status"] | null;
  label: string;
}> = [
  { value: null, label: "Все" },
  { value: "new", label: "Новые" },
  { value: "in_progress", label: "В работе" },
  { value: "resolved", label: "Решённые" },
  { value: "closed", label: "Закрытые" },
];

export function formatFeedbackDate(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function truncateMessage(message: string, maxLen = 80): string {
  if (message.length <= maxLen) return message;
  return `${message.slice(0, maxLen).trimEnd()}…`;
}

export function formatTimelineDate(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatStatusChangeLabel(
  oldStatus: FeedbackResponseDto["status"] | null | undefined,
  newStatus: FeedbackResponseDto["status"] | null | undefined,
): string {
  if (oldStatus && newStatus) {
    return `Статус изменён: ${FEEDBACK_STATUS_LABEL[oldStatus]} → ${FEEDBACK_STATUS_LABEL[newStatus]}`;
  }
  if (newStatus) {
    return `Статус: ${FEEDBACK_STATUS_LABEL[newStatus]}`;
  }
  return "Изменение статуса";
}

export type FeedbackStatusAction = {
  status: FeedbackResponseDto["status"];
  label: string;
};

export function getFeedbackClientPhone(
  feedback: FeedbackDetailResponseDto,
): string | null {
  const extended = feedback as FeedbackDetailResponseDto & {
    phone?: string | null;
    client_phone?: string | null;
  };
  return extended.client_phone ?? extended.phone ?? null;
}

export function getFeedbackStatusActions(
  current: FeedbackResponseDto["status"],
): FeedbackStatusAction[] {
  const actions: FeedbackStatusAction[] = [];

  if (current === "new") {
    actions.push({
      status: "in_progress",
      label: "Взять в работу",
    });
  }

  if (current !== "resolved" && current !== "closed") {
    actions.push({
      status: "resolved",
      label: "Отметить решенным",
    });
  }

  if (current !== "closed") {
    actions.push({
      status: "closed",
      label: "Закрыть",
    });
  }

  return actions;
}
